import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "d4fd5fd5",
    requestDate: "25/03/2002",
    remarks: "47",
    amount: "$4888",
    payRemarks: "49",
    payDate: "15/03/2022",
    status: "pending",
  },
  {
    id: "f7s8fdsf",
    requestDate: "25/03/2002",
    remarks: "47",
    amount: "$4888",
    payRemarks: "49",
    payDate: "15/03/2022",
    status: "pending",
  },
  {
    id: "ds7fs5fd",
    requestDate: "25/03/2002",
    remarks: "47",
    amount: "$4888",
    payRemarks: "49",
    payDate: "15/03/2022",
    status: "pending",
  },
];

const columns = [
  { id: "id", label: "ID #", minWidth: 20 },
  { id: "requestDate", label: "Request Date", minWidth: 100 },
  {
    id: "remarks",
    label: "Remarks",
    minWidth: 80,
  },
  {
    id: "amount",
    label: "	Amount",
    minWidth: 80,
  },
  {
    id: "payRemarks",
    label: "Pay Remarks",
    minWidth: 80,
  },
  {
    id: "payDate",
    label: "Pay Date",
    minWidth: 80,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
  },
];

function createData(
  id,
  requestDate,
  remarks,
  amount,
  payRemarks,
  payDate,
  status
) {
  return {
    id,
    requestDate,
    remarks,
    amount,
    payRemarks,
    payDate,
    status,
  };
}

const rows = dataJson.map((d) =>
  createData(
    d.id,
    d.requestDate,
    d.remarks,
    d.amount,
    d.payRemarks,
    d.payDate,
    d.status
  )
);

const WithdrawReportStatusTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default WithdrawReportStatusTable;
